<template>
    <div>
        <app-template>
            <div class="bg-white p-4 rounded shadow border">
                <h1 class="text-2xl font-bold mb-4">Parametre List</h1>
                <ul class="list-disc ml-4">
                    <li>
                        <div>Planning</div>
                        <div class="ml-4">
                            <ul class="list-disc">
                                <li>Jour d'ouverture</li>
                                <li>Heures d'ouverture</li>
                            </ul>
                        </div>
                    </li>
                    <li>Gestion des capacités employés</li>
                    <li>
                        <div>Gestion des types d'intervention</div>
                        <div class="ml-4">
                            <ul class="list-disc">
                                <li>Nom</li>
                                <li>Durée</li>
                                <li>Type de capacité employé</li>
                                <li>Prix</li>
                            </ul>
                        </div>
                    </li>
                    <li>
                        <div>Facturation</div>
                        <div class="ml-4">
                            <ul class="list-disc">
                                <li>Marge</li>
                                <li>Pied de devis</li>
                                <li>Pied de facture</li>
                                <li>RIB</li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>
        </app-template>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>